import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Avatar, Box, ButtonBase, Divider, Grid, } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb.js";
import Header from "../../components/VerticalLayout/Header";
import "./setting.css";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog.js";
import Notification from "../../components/Common/Notification.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { createAdmin, createShippingZone, deleteAdmin, deleteShippingZone, getAdminListing, getGeneral, getShippingZoneListing, logoutUser, resetAdminActionState, resetProfileActionState, resetShippingZoneActionState, updateAdmin, updateAdminPassword, updateProfile, updateShippingZone, updateShippingZoneActivation, verify_admin } from "../../store/actions.js";
import CustomButton from "../../components/Form/CustomButton.js";
import EditProfileModal from "./modal/EditProfile.js";
import Label from "../../components/Common/Label.js";
import ChangePasswordModal from "./modal/ChangePassword.js";
import Table from "../../components/Common/Table.js";
import TablePageControl from "../../components/Common/TablePageControl.js";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import AddAdminModal from "./modal/AddAdmin.js";
import DeleteModal from "../../components/Common/DeleteModal.js";
import Helpers from "../../helpers/helpers.js";
import AddShippingZoneModal from "./modal/AddShippingZone.js";
import ActivateShippingZoneModal from "./modal/ShippingZoneActivation.js";


const Setting = ({
    userPermission, leftSideBarType, userData, adminListing, shippingZoneListing, addShippingZone,
    editShippingZone, roleList, addAdmin, editAdmin, countryList, width, stateList, editProfile,
    deleteAdminRes, deleteShippingZoneRes, updateAdminPwd, activateShippingZone
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setIsLoading] = useState(false);
    const [currentSection, setCurrentSection] = useState("Account");
    const [profileObj, setProfileObj] = useState({});
    const [editPasswordOpen, setEditPasswordOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState(10);
    const [shippingPage, setShippingPage] = useState(1);
    const [shippingLength, setShippingLength] = useState(10);
    const [selectedRow, setSelectedRow] = useState();
    const [updateActivationItem, setUpdateActivationItem] = useState();
    const [deleteShippingZoneOpen, setDeleteShippingZoneOpen] = useState(false);
    const [addShippingOpen, setAddShippingOpen] = useState(false);
    const [activateOpen, setActivateOpen] = useState(false);
    const [removeAdminOpen, setRemoveAdminOpen] = useState(false);
    const [addAdminOpen, setAddAdminOpen] = useState(false);
    const [adminFormObj, setAdminFormObj] = useState();
    const [error, setError] = useState();
    const [editOpen, setEditOpen] = useState(false);
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });


    const header = [
        {
            Header: "Name",
            accessor: (cellProps) => {
                return (
                    <div className="d-flex align-items-center">
                        <Avatar src={cellProps?.photo || ''} style={{ height: 32, width: 32, marginRight: 10 }}></Avatar>
                        <div>
                            <div className="d-flex align-items-center">
                                {cellProps?.name || "-"}
                                {userData?.id === cellProps?.id && <Label.CustomLabel label={'You'} backgroundColor={'#F3F4F6'} borderRadius={"6px"} marginLeft={"5px"} />}
                            </div>
                            <div className="subheader-2">{cellProps?.email || "-"}</div>
                        </div>
                    </div>
                )
            },
        },
        {
            Header: "Role",
            accessor: (cellProps) => {
                return (cellProps?.role || "-")
            },
        },
        {
            Header: "Phone Number",
            accessor: (cellProps) => {
                return (cellProps?.phone || "-")
            },
        },
        {
            Header: "Last Signed In",
            minWidth: 150,
            accessor: (cellProps) => {
                return (cellProps?.login || "-")
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                const actionItems = [
                    { label: 'Edit', iconName: 'mdi:edit-outline', color: '#594A4E', permission: true, onClick: () => { setAddAdminOpen(true); setSelectedRow(cellProps); setAdminFormObj({ ...cellProps, phone: cellProps?.phone?.startsWith('60') ? cellProps.phone.slice(2) : cellProps.phone || '' }) } },
                    { label: 'Remove', iconName: 'mdi:minus-circle-outline', color: '#D7114D', permission: true, onClick: () => { setSelectedRow(cellProps); setRemoveAdminOpen(true) } },
                ]
                return (userData?.id !== cellProps?.id && <RenderPopOverButton items={actionItems} />)
            },
        },
    ]

    const shippingHeader = [
        {
            Header: "Zone Name",
            accessor: (cellProps) => {
                return (
                    <div>
                        {cellProps?.name || "-"}
                        <Label.GeneralStatusLabel label={cellProps?.status} list={Helpers.activeinvoiceStatus} marginLeft={"0px"} />
                    </div>
                )
            },
        },
        {
            Header: "Country",
            accessor: (cellProps) => {
                return (cellProps?.country || "-")
            },
        },
        {
            Header: "States",
            accessor: (cellProps) => {
                return (cellProps?.states || "-")
            },
        },
        {
            Header: "Shipping Fee (RM)",
            accessor: (cellProps) => {
                return (cellProps?.fee ? `${cellProps?.fee}` : "-")
            },
        },
        {
            Header: "Free Shipping Threshold (RM)",
            accessor: (cellProps) => {
                return (cellProps?.threshold ? `${cellProps?.threshold}` : "-")
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                const actionItems = [
                    { label: 'Edit', iconName: 'mdi:edit-outline', color: '#594A4E', permission: true, onClick: () => { { if (error) { setError(null) } setAddShippingOpen(true); setSelectedRow({ ...cellProps, states: cellProps?.state_ids || [] }) } } },
                    { label: cellProps?.status == '1' ? 'Deactivate' : 'Activate', iconName: cellProps?.status == '1' ? 'mdi:account-off-outline' : 'mdi:account-check-outline', color: '#594A4E', permission: true, onClick: () => { setUpdateActivationItem(cellProps); setActivateOpen(true) } },
                    { label: 'Delete', iconName: 'mdi:delete-outline', color: '#D7114D', permission: true, onClick: () => { setSelectedRow(cellProps); setDeleteShippingZoneOpen(true) } },
                ]
                return (<RenderPopOverButton items={actionItems} />)
            },
        },
    ]

    useEffect(() => {
        dispatch(getGeneral());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
        }
    }, [userPermission])

    useEffect(() => {
        initData();
    }, [currentSection])

    useEffect(() => {
        initData();
    }, [page, length, shippingPage, shippingLength])

    useEffect(() => {
        if (adminListing?.data) {
            setIsLoading(false);
        }
    }, [adminListing])

    useEffect(() => {
        if (addAdmin?.code === "success") {
            setIsLoading(false);
            setAddAdminOpen(false);
            setNotification({ type: 'success', msg: 'Admin added successfully', open: true });
            error && setError(null);
            dispatch(resetAdminActionState());
            initData();
        } else if (addAdmin?.code === 'invalid_field') {
            setIsLoading(false);
            setError(addAdmin?.errors || {});
            setNotification({ type: 'error', msg: 'Invalid field', open: true });
            dispatch(resetAdminActionState());
        }
    }, [addAdmin])

    useEffect(() => {
        if (editAdmin?.code === "success") {
            setIsLoading(false);
            setAddAdminOpen(false);
            setNotification({ type: 'success', msg: 'Admin updated successfully', open: true });
            error && setError(null);
            dispatch(resetAdminActionState());
            initData();
        } else if (editAdmin?.code === 'invalid_field') {
            setIsLoading(false);
            setError(editAdmin?.errors || {});
            setNotification({ type: 'error', msg: 'Invalid field', open: true });
            dispatch(resetAdminActionState());
        }
    }, [editAdmin])

    useEffect(() => {
        if (deleteAdminRes?.code === "success") {
            setIsLoading(false);
            setRemoveAdminOpen(false);
            setNotification({ type: 'success', msg: 'Admin deleted successfully', open: true });
            error && setError(null);
            dispatch(resetAdminActionState());
            initData();
        } else if (deleteAdminRes?.code === 'invalid_field') {
            setIsLoading(false);
            setError(deleteAdminRes?.errors || {});
            setNotification({ type: 'error', msg: 'Invalid field', open: true });
            dispatch(resetAdminActionState());
        }
    }, [deleteAdminRes])

    useEffect(() => {
        if (editProfile?.code === "success") {
            setIsLoading(false);
            setEditOpen(false);
            setNotification({ type: 'success', msg: 'Profile updated successfully', open: true });
            error && setError(null);
            dispatch(resetProfileActionState());
            dispatch(verify_admin());
            dispatch(getGeneral());
        } else if (editProfile?.code === 'invalid_field' || editProfile?.code === 'error') {
            setIsLoading(false);
            setError(editProfile?.errors || {});
            setNotification({ type: 'error', msg: 'Invalid field', open: true });
            dispatch(resetProfileActionState());
        }
    }, [editProfile])

    useEffect(() => {
        if (updateAdminPwd?.code === "success") {
            setEditPasswordOpen(false);
            setIsLoading(false);
            setNotification({ type: 'success', msg: 'Password updated successfully', open: true });
            error && setError(null);
            dispatch(resetAdminActionState());
        } else if (updateAdminPwd?.code === 'invalid_field') {
            setIsLoading(false);
            setError(updateAdminPwd?.errors || {});
            setNotification({ type: 'error', msg: 'Invalid field', open: true });
        } else if (updateAdminPwd?.code === 'error') {
            setIsLoading(false);
            setNotification({ type: 'error', msg: updateAdminPwd?.message || 'Something went wrong, please try again later', open: true });
        }
    }, [updateAdminPwd])

    useEffect(() => {
        if (shippingZoneListing?.data) {
            setIsLoading(false);
        }
    }, [shippingZoneListing])

    useEffect(() => {
        if (editShippingZone?.code === "success" || addShippingZone?.code === "success") {
            setNotification({
                open: true,
                msg: "Shipping zone updated successfully",
                type: "success",
            });
            setAddShippingOpen(false);
            selectedRow && setSelectedRow(null);
            dispatch(resetShippingZoneActionState());
            initData();
        } else if (editShippingZone?.code === 'invalid_field' || addShippingZone?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: "Invalid field",
                type: "error",
            })
            setError(editShippingZone?.errors || addShippingZone?.errors || {});
            dispatch(resetShippingZoneActionState());
        }
    }, [editShippingZone, addShippingZone])

    useEffect(() => {
        if (deleteShippingZoneRes?.code === "success") {
            setIsLoading(false);
            setDeleteShippingZoneOpen(false);
            setNotification({ type: 'success', msg: 'Shipping zone deleted successfully', open: true });
            error && setError(null);
            dispatch(resetShippingZoneActionState());
            initData();
        } else if (deleteShippingZoneRes?.code === 'invalid_field') {
            setIsLoading(false);
            setError(deleteShippingZoneRes?.errors || {});
            setNotification({ type: 'error', msg: 'Invalid field', open: true });
            dispatch(resetShippingZoneActionState());
        }
    }, [deleteShippingZoneRes])

    useEffect(() => {
        if (activateShippingZone?.code === "success") {
            setIsLoading(false);
            setActivateOpen(false);
            setNotification({ type: 'success', msg: 'Shipping zone updated successfully', open: true });
            error && setError(null);
            dispatch(resetShippingZoneActionState());
            setUpdateActivationItem(null);
            initData();
        }
    }, [activateShippingZone])

    const settingList = [
        {
            module: 'ACCOUNT'
        },
        {
            iconName: 'mdi:account-outline',
            title: 'Account',
        },
        {
            iconName: 'mdi:lock-outline',
            title: 'Login & Security',
        },
        {
            iconName: 'mdi:account-tie-outline',
            title: 'Manage Admins',
        },
        {
            module: 'CONFIGURATION'
        },
        {
            iconName: 'mdi:truck-outline',
            title: 'Shipping Settings',
        },
    ]

    const initData = () => {
        if (currentSection === 'Manage Admins') {
            setIsLoading(true);
            dispatch(getAdminListing({ page: page, length: length }));
        } else if (currentSection === 'Shipping Settings') {
            setIsLoading(true);
            dispatch(getShippingZoneListing({ page: shippingPage, length: shippingLength }));
        }
    }



    const handleAddNewAdmin = (data) => {
        let payload = {
            name: data?.name || '',
            email: data?.email || '',
            phone: data?.phone ? `60${data?.phone}` : '',
            role_id: data?.role_id || '',
        }
        if (Boolean(selectedRow)) {
            dispatch(updateAdmin({ id: selectedRow?.id, data: payload }));
        } else {
            dispatch(createAdmin(payload));
        }
    }

    const handleAccountUpdate = async () => {
        setIsLoading(true);
        let payload = {
            name: profileObj?.name || '',
            email: profileObj?.email || '',
            phone: profileObj?.phone || '',
        }
        if (profileObj?.pfp_base64) {
            payload.profile_photo = profileObj?.pfp_base64;
        } else {
            payload.remove_photo = 1;
        }
        dispatch(updateProfile(payload));
    }

    const handleShippingZoneUpdate = (data) => {
        let payload = {}
        if (Boolean(selectedRow)) {
            payload.id = selectedRow?.id;
            payload.data = {
                country_id: data?.country_id || '',
                states: data?.states || '',
                name: data?.name || '',
                shipping_fee: data?.fee || 0,
                offer: data?.offer_shipping_fee ? 1 : 0,
                free_shipping_threshold: data?.threshold || 0,
            }
            dispatch(updateShippingZone(payload));
        } else {
            payload.country_id = data?.country_id || '';
            payload.states = data?.states || '';
            payload.name = data?.name || '';
            payload.shipping_fee = data?.fee || 0;
            payload.offer = data?.offer_shipping_fee ? 1 : 0;
            payload.free_shipping_threshold = data?.threshold || null;
            dispatch(createShippingZone(payload));
        }

    }

    const handleUpdatePassword = (data) => {
        let payload = {
            current_password: data?.current_password || '',
            password: data?.new_password || '',
            confirm_password: data?.confirm_password || '',
        }
        dispatch(updateAdminPassword(payload));
    }

    const handleSubmit = (data) => {
        setIsLoading(true);
        if (currentSection === 'Manage Admins') {
            handleAddNewAdmin(data);
        } else if (currentSection === 'Account') {
            handleAccountUpdate(data);
        } else if (currentSection === 'Shipping Settings') {
            handleShippingZoneUpdate(data);
        } else if (editPasswordOpen === true) {
            handleUpdatePassword(data);
        }

    }

    const handleDeleteAdmin = () => {
        setIsLoading(true);
        dispatch(deleteAdmin({ id: selectedRow?.id }));
    }

    const handleDeleteShippingZone = () => {
        setIsLoading(true);
        dispatch(deleteShippingZone({ id: selectedRow?.id }));
    }

    const handleShippingZoneActivation = () => {
        setIsLoading(true);
        dispatch(updateShippingZoneActivation({
            id: updateActivationItem?.id,
            activation: updateActivationItem?.status === '1' ? 'deactivate' : 'activate'
        }));
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const getShippingLengthPage = (page, length) => {
        setShippingPage(page)
        setShippingLength(length)
    }

    const handleLogout = () => {
        setIsLoading(true);
        dispatch(logoutUser());
    }

    const renderAccount = () => {
        return (
            <Grid container spacing={2}>
                <Grid item lg={3} md={3}>

                </Grid>
                <Grid item lg={10} md={10} className="d-flex">
                    <Avatar src={userData?.profile_photo_path || ''} style={{ height: 120, width: 120, marginRight: 30, marginLeft: 10 }}></Avatar>
                    <div>
                        <div className="subheader-2">Full Name</div>
                        <div className="mb-3 font-size-16">{userData?.name || '-'}</div>
                        <div className="subheader-2">Phone Number</div>
                        <div className="mb-3 font-size-16">{userData?.phone || '-'}</div>
                        <div className="subheader-2">Email Address</div>
                        <div className="mb-3 font-size-16">{userData?.email || '-'}</div>
                    </div>
                </Grid>
                <Grid item lg={2} md={2} sx={{ display: 'flex', justifyContent: { lg: 'flex-end', md: 'flex-end' } }}>
                    <CustomButton
                        title={'Edit profile'}
                        backgroundColor={'#F9F9F9'}
                        borderStyle={'1px solid #F9F9F9'}
                        textColor={'#594A4E'}
                        press={() => { setProfileObj(userData); setEditOpen(true) }}
                    />
                </Grid>
            </Grid>
        )
    }

    const renderLoginSecurity = () => {
        return (
            <div>
                <Grid container spacing={2} pb={2}>
                    <Grid item sm={12} xs={12} className="font-size-18 text-semibold mb-3">Account Information</Grid>
                    <Grid item sm={12} xs={12} className="subheader-3">Email Address</Grid>
                    <Grid item sm={12} xs={12} className="subheader-2 d-flex align-items-center">
                        {userData?.email || '-'}
                        <Label.GeneralStatusLabel label={'verified'} list={[{ label: 'Verified', value: 'verified', statusColor: 'green' }]} />
                    </Grid>
                    <Grid item sm={12} xs={12} className="subheader-3">Phone Number</Grid>
                    <Grid item sm={12} xs={12} className="subheader-2 d-flex align-items-center">
                        {userData?.phone || '-'}
                        <Label.GeneralStatusLabel label={'verified'} list={[{ label: 'Verified', value: 'verified', statusColor: 'green' }]} />
                    </Grid>
                    <Grid item sm={12} xs={12} className="my-3">
                        <Divider />
                    </Grid>
                    <Grid item sm={12} xs={12} className="font-size-18 text-semibold mb-3">Login Security</Grid>
                    <Grid item sm={12} xs={12} sx={{ display: { lg: 'flex', md: 'flex', sm: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between', sm: 'space-between' } }}>
                        <Box>
                            Change password
                            <div className="subheader-2 my-2">Update your password to keep your account secure.</div>
                        </Box>
                        <CustomButton
                            title={'Change Password'}
                            backgroundColor={'#F9F9F9'}
                            borderStyle={'1px solid #F9F9F9'}
                            textColor={'#594A4E'}
                            press={() => setEditPasswordOpen(true)}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12} className="my-3">
                        <Divider />
                    </Grid>
                    <Grid item sm={12} xs={12} className="font-size-18 text-semibold mb-3">Logout</Grid>
                    <Grid item sm={12} xs={12} sx={{ display: { lg: 'flex', md: 'flex', sm: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between', sm: 'space-between' } }}>
                        <Box>
                            Log out of your account
                            <div className="subheader-2 my-2">Logging out will end your current session. You can log back in anytime.</div>
                        </Box>
                        <CustomButton
                            title={'Log Out'}
                            backgroundColor={'#FFEBEC'}
                            borderStyle={'1px solid #FFEBEC'}
                            textColor={'#D7114D'}
                            press={() => handleLogout()}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }

    const renderAdminManagement = () => {
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="font-size-18 text-semibold">Admin Management</div>
                    <CustomButton
                        title={<div className="d-flex align-items-center"><Icon icon={'mdi:plus'} style={{ marginRight: 5 }} />New Admin</div>}
                        backgroundColor={'#FFFFFF'}
                        borderStyle={'1px solid #0E172C'}
                        textColor={'#0E172C'}
                        press={() => {
                            if (selectedRow) { setSelectedRow(null) }
                            error && setError(null);
                            setAdminFormObj(null);
                            setAddAdminOpen(true)
                        }}
                    />
                </div>
                <Table
                    header={header}
                    data={adminListing?.data || []}
                    pageSize={length}
                    totalPage={adminListing?.last_page || 1}
                    getLengthPage={getLengthPage}
                />
                <TablePageControl
                    from={0}
                    to={0}
                    total={adminListing?.total || 0}
                    length={length}
                    setLength={setLength}
                    page={page}
                    setPage={setPage}
                    totalPage={adminListing?.last_page || 1}
                />
            </div>
        )
    }

    const renderShipping = () => {
        return (
            <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="font-size-18 text-semibold">Shipping Zones</div>
                    <CustomButton
                        title={<div className="d-flex align-items-center"><Icon icon={'mdi:plus'} style={{ marginRight: 5 }} />New shipping zone</div>}
                        backgroundColor={'#FFFFFF'}
                        borderStyle={'1px solid #0E172C'}
                        textColor={'#0E172C'}
                        press={() => { setAddShippingOpen(true) }}
                    />
                </div>
                <Table
                    header={shippingHeader}
                    data={shippingZoneListing?.data || []}
                    pageSize={shippingLength}
                    totalPage={shippingZoneListing?.last_page || 1}
                    getLengthPage={getShippingLengthPage}
                />
                <TablePageControl
                    from={0}
                    to={0}
                    total={shippingZoneListing?.total || 0}
                    length={shippingLength}
                    setLength={setShippingLength}
                    page={shippingPage}
                    setPage={setShippingPage}
                    totalPage={shippingZoneListing?.last_page || 1}
                />
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ maxHeight: '100vh', marginLeft: 768 < width && width <= 1024 && leftSideBarType === 'condensed' ? 70 : 0 }}>
                <LoadingDialog open={loading} />
                <Header
                    breadcrumb={<Breadcrumbs
                        breadcrumbItems={[{ title: 'Settings', link: "#" }]} />
                    }
                />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Grid container spacing={2}>
                        <Grid item lg={2.5} md={3.5} sm={12} sx={{ display: { lg: 'block', md: 'block', sm: 'flex', xs: 'flex' }, overflowX: 'auto', width: { sm: '100%' } }}>
                            {
                                settingList.map((item, index) => (
                                    <>
                                        {
                                            item?.module ?
                                                <div key={index} className="subheader-2 mt-3 my-2">{item.module}</div>
                                                :
                                                <ButtonBase key={index} className="d-flex align-items-center mb-2" style={{ backgroundColor: currentSection === item.title ? '#FFEBEC' : 'transparent', color: currentSection === item.title ? '#D7114D' : '#454545', padding: 7, paddingInline: 10, borderRadius: 7, width: '100%' }} onClick={() => setCurrentSection(item.title)}>
                                                    <Grid container spacing={1} alignItems="center" ml={0} paddingInline={"0px"} display={"flex"} style={{ minWidth: 200 }}>
                                                        <Grid item md={2} sm={2}>
                                                            <Icon icon={item.iconName} width={24} height={24} color={currentSection === item.title ? "#D7114D" : "#808588"} />
                                                        </Grid>
                                                        <Grid item md={10} sm={10} className="d-flex justify-content-start">
                                                            <div>{item.title}</div>
                                                        </Grid>
                                                    </Grid>
                                                </ButtonBase>
                                        }
                                    </>
                                ))
                            }
                        </Grid>
                        <Grid item lg={9.5} md={8.5} style={{ overflow: 'auto' }}>
                            <div style={{ overflow: 'auto', maxHeight: '85vh', paddingBottom: 70, paddingTop: 10 }}>
                                {currentSection === 'Account' && renderAccount()}
                                {currentSection === 'Login & Security' && renderLoginSecurity()}
                                {currentSection === 'Manage Admins' && renderAdminManagement()}
                                {currentSection === 'Shipping Settings' && renderShipping()}
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <EditProfileModal
                open={editOpen}
                close={() => setEditOpen(false)}
                submit={() => handleSubmit()}
                formObj={profileObj}
                setFormObj={setProfileObj}
                error={error}
            />
            <ChangePasswordModal
                open={editPasswordOpen}
                close={() => setEditPasswordOpen(false)}
                submit={(data) => handleSubmit(data)}
                error={error}
            />
            <AddAdminModal
                open={addAdminOpen}
                close={() => { setAddAdminOpen(false); setSelectedRow(null); error && setError(null) }}
                submit={(data) => handleSubmit(data)}
                formObj={adminFormObj}
                setFormObj={setAdminFormObj}
                roleList={roleList || []}
                error={error}
            />
            <ActivateShippingZoneModal
                open={activateOpen}
                close={() => setActivateOpen(false)}
                isActive={updateActivationItem?.status === '1'}
                submit={(data) => { handleShippingZoneActivation() }}
            />
            <AddShippingZoneModal
                open={addShippingOpen}
                close={() => { setAddShippingOpen(false); setSelectedRow(null); error && setError(null) }}
                submit={(data) => handleSubmit(data)}
                isEdit={Boolean(selectedRow)}
                dispatch={dispatch}
                countryList={countryList || []}
                stateList={stateList || []}
                initialData={selectedRow || null}
                error={error}
            />
            <DeleteModal
                open={removeAdminOpen}
                close={() => setRemoveAdminOpen(false)}
                title={`Remove admin`}
                positiveTitle={'Remove'}
                verification={false}
                submit={() => handleDeleteAdmin()}
                message={
                    <>
                        <div className="mb-3">You are about to remove this admin from the system.</div>
                        <div>
                            Removing this admin will revoke their access immediately, and they will no longer be able to log in or manage the platform. This action cannot be undone.
                        </div>
                    </>
                }
            />
            <DeleteModal
                open={deleteShippingZoneOpen}
                close={() => setDeleteShippingZoneOpen(false)}
                title={`Delete shipping zone`}
                positiveTitle={'Delete'}
                verification={false}
                submit={() => handleDeleteShippingZone()}
                message={
                    <>
                        <div className="mb-3">You are about to permanently delete this shipping zone.</div>
                        <div>
                            Deleting this zone will remove all associated delivery Shipping Settings and settings for this region. This action cannot be undone.
                        </div>
                    </>
                }
            />
        </React.Fragment>
    );
};

function mapStateToProps({ ReuseableReducer, Login, Layout, Admin, ShippingZone, Profile, General }) {
    return {
        userPermission: Login.permissionArry,
        settingListing: ReuseableReducer.reuseableList,
        updateSetting: ReuseableReducer.editReuseableSetting,
        leftSideBarType: Layout.leftSideBarType,
        width: Layout.currentWidth,
        editProfile: Profile?.editProfile,
        userData: Login?.verifyAdmin?.user?.data?.profile,
        adminListing: Admin?.adminListing?.data,
        addAdmin: Admin?.addAdmin,
        editAdmin: Admin?.updateAdmin,
        deleteAdminRes: Admin?.deleteAdmin,
        updateAdminPwd: Admin?.updateAdminPwd,
        shippingZoneListing: ShippingZone?.shippingZoneListing?.data,
        editShippingZone: ShippingZone?.updateShippingZone,
        activateShippingZone: ShippingZone?.updateShippingZoneActivation,
        addShippingZone: ShippingZone?.addShippingZone,
        deleteShippingZoneRes: ShippingZone?.deleteShippingZone,
        roleList: General?.roles,
        countryList: General?.countries,
        stateList: General?.states,
    };
}

export default connect(mapStateToProps)(Setting);